/**
 * @deprecated
 */
export const getObjectLinkDeprecated = (
  id?: string,
  type?: string,
  versionId?: string,
): string =>
  `/share/${type}/${id}${versionId ? `/v/${versionId}` : ''}/?${
    window.location.href.split('?')[1]
  }`;
